export const SET_CUSTOMER_URL = 'setCustomerUrl'
export const SET_IS_CONTINUE_LATER = 'setIsContinueLater'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'

export default {
  SET_CUSTOMER_URL,
  SET_IS_CONTINUE_LATER,
  SET_CURRENT_USER
}
